import { Component, Input, inject } from '@angular/core';
import { PortalStateService } from '../../../services/portal-state.service';

export interface BlueprintCard {
  id: string;
  name: string;
  instancesCount: number | null;
  solutionId: string;
  solutionName: string;
}

@Component({
  selector: 'app-service-definition-cards',
  templateUrl: './service-definition-cards.component.html',
  styleUrls: ['./service-definition-cards.component.scss'],
  standalone: false
})
export class ServiceDefinitionCardsComponent {
  @Input() blueprintCards: BlueprintCard[] = [];
  @Input() loader = false;

  readonly skeletonItems = [1, 2, 3, 4];

  private readonly portalStateService = inject(PortalStateService);

  navigateToServiceDetails(card: BlueprintCard): void {
    this.portalStateService.viewServiceDetails(card.solutionId, card.name, card.id);
  }
}
